import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import PriceInput from 'components/PriceInput';
import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';
import OrderEditPaymentsTable from 'components/OrderEditMainPaymentsTable';
import OrderEditInvoice from 'components/OrderEditInvoice';

import { OrderEditMainPayments_order$key } from '__generated__/OrderEditMainPayments_order.graphql';

type Props = {
  order: OrderEditMainPayments_order$key;
};

const OrderEditMainPayments: FC<Props> = props => {
  const order = useFragment(
    graphql`
      fragment OrderEditMainPayments_order on Order {
        priceTotal
        priceAdvancePayment
        totalPaid
        remainingPayment
        remainingPaymentDeadline
        paymentTypeText

        ...OrderEditMainPaymentsTable_order
        ...OrderEditInvoice_order
      }
    `,
    props.order
  );

  return (
    <Section id="payments" title="Atsiskaitymas">
      <Stack spacing={4}>
        <TwoColumn
          left={
            <PriceInput
              fullWidth
              disabled
              label="Kelionės kaina"
              variant="standard"
              value={order.priceTotal}
            />
          }
          right={
            <PriceInput
              fullWidth
              disabled
              label="Avansas"
              variant="standard"
              value={order.priceAdvancePayment}
            />
          }
        />

        <TwoColumn
          left={
            <PriceInput
              fullWidth
              disabled
              label="Viso sumokėta"
              variant="standard"
              value={order.totalPaid}
            />
          }
          right={
            <PriceInput
              fullWidth
              disabled
              label="Liko mokėti"
              variant="standard"
              value={order.remainingPayment}
            />
          }
        />

        <TwoColumn
          left={
            <TextField
              fullWidth
              disabled
              label="Likutį mokėti iki"
              variant="standard"
              value={order.remainingPaymentDeadline}
            />
          }
          right={
            <TextField
              fullWidth
              disabled
              label="Pasirinktas apmokėjimo būdas"
              variant="standard"
              value={order.paymentTypeText}
            />
          }
        />
      </Stack>

      <OrderEditPaymentsTable order={order} />
      <OrderEditInvoice order={order} />
    </Section>
  );
};

export default OrderEditMainPayments;
